<template>
  <div class="mainBox">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="气象" name="first">
        <qx v-if="activeName === 'first'" />
      </el-tab-pane>
      <el-tab-pane label="墒情" name="second">
        <sq v-if="activeName === 'second'" />
      </el-tab-pane>
      <el-tab-pane label="视频" name="third">
        <nq v-if="activeName === 'third'" />
      </el-tab-pane>
      <!--
      <el-tab-pane label="农机" name="fourth">
        <nj v-if="activeName === 'fourth'" />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
// import { getIndexByPositionCode } from "@/api/base";
import qx from "./base/qx";
import sq from "./base/sq";
// import cq from "./base/cq";
// import nj from "./base/nj";
import nq from "./base/nq";
export default {
  components: {
    qx,
    sq,
    // cq,
    // nj,
    nq
  },
  data() {
    return {
      activeName: "first",
      list: [
        { name: "气象" },
        { name: "墒情" },
        { name: "农情" }
        // { name: "农机" }
      ],
      qxlist: [],
      isChoose: 0,
      key: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {},
    handleClick(item, index) {
      this.isChoose = index;
    },
    handleMore() {
      // getIndexByPositionCode({ positionCode: "zhwl" }).then(res => {
      //   if (res.code === 200) {
      //     this.$store.dispatch("map/setLayerIndexId", res.data[0].zb_indexId);
      //     this.$store.dispatch("map/setLayerComponent", "zhwlLayer");
      //   }
      // });
    }
  },
  destroyed() {
    clearInterval(this.key);
  }
};
</script>

<style lang="stylus" scoped>
.mainBox
  height calc(100% - 10px)
  width calc(100% - 10px)
  margin-top 10px
  padding 0 5px

>>>.el-tabs__nav-wrap::after
    background-color transparent
>>>.el-tabs__active-bar
    background-color transparent
>>>.el-tabs__nav-scroll
    background-color #21446e
>>>.el-tabs__item.is-active
    color: #0ff;
>>>.el-tabs--top .el-tabs__item.is-top:nth-child(2)
    padding-left 20px
>>>.el-tabs__item
    color #fff
    height 25px
    line-height 25px
>>>.el-tabs__header
    margin 0
>>>.el-tabs
    // height calc(100% - 31px)
    height 100%
>>>.el-tabs__content
    height calc(100% - 20px)
>>>.el-tab-pane
    height 100%
</style>
